<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h1>Platform / Radio</h1>
  </div>
</div>

<div class="form">
  <form [formGroup]="form">
    <div class="row">
      <div class="col-6 ui-platform-form-control">
        <ui-platform-radio
          formControlName="carbonNeutral"
          [options]="options"></ui-platform-radio>
      </div>
    </div>
  </form>
</div>

<div class="row">
  <div class="col-8">
    <h2>Code</h2>
    <p>Declare module:</p>
    <pre>{{ import }}</pre>
    <p>Define form and options for the radio group:</p>
    <pre>{{ usageCode }}</pre>
    <p>Use component in a template:</p>
    <pre>{{ usageTemplate }}</pre>
    <p><i>Note: display of errors in not part of a component, implemented as ui-platform-form-control classes</i></p>
  </div>
</div>
